<p>swish-purchase works!</p>
